export default "__VITE_ASSET__3367e3ed__"